(() => {
  if (window.__NT_CART_UPSELL_LOADED__) return;
  window.__NT_CART_UPSELL_LOADED__ = true;

  const getDrawer = () => document.querySelector('cart-drawer');

  function setButtonState(button, loading, text) {
    if (!button) return;
    if (!button.dataset.originalText) button.dataset.originalText = button.innerHTML;
    button.disabled = loading;
    if (text) {
      button.textContent = text;
    } else if (!loading) {
      button.innerHTML = button.dataset.originalText;
    }
  }

  async function addUpsell(button) {
    const card = button.closest('[data-nt-upsell-card]');
    if (!card) return;

    const select = card.querySelector('[data-nt-upsell-variant]');
    const variantId = select?.value || button.dataset.variantId;
    if (!variantId) return;

    setButtonState(button, true, 'Wird hinzugefügt…');

    try {
      const drawer = getDrawer();
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          drawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof drawer.setActiveElement === 'function') {
          drawer.setActiveElement(document.activeElement);
        }
      }

      config.body = formData;

      const response = await fetch(routes.cart_add_url, config);
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Produkt konnte nicht hinzugefügt werden.');
      }

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else {
        window.location.assign(routes.cart_url);
      }

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'nt-cart-upsell',
          productVariantId: variantId,
          cartData: data,
        });
      }
    } catch (error) {
      console.error('[NeverTap Cart Upsell]', error);
      setButtonState(button, false);
      button.textContent = 'Fehler – erneut versuchen';
      window.setTimeout(() => setButtonState(button, false), 1800);
    }
  }

  function updateUpsellPrice(select) {
  const card = select.closest('[data-nt-upsell-card]');
  if (!card) return;

  const option = select.options[select.selectedIndex];

  const price = card.querySelector('[data-nt-upsell-price]');
  const compare = card.querySelector('[data-nt-upsell-compare]');
  const saving = card.querySelector('[data-nt-upsell-saving]');
  const bundleTotal =
  card.querySelector('[data-nt-bundle-total]');

const bundleSaving =
  card.querySelector('[data-nt-bundle-saving]');
  const addButton = card.querySelector('[data-nt-upsell-add]');

  const discountPercent = Number(
    option.dataset.discountPercent || 0
  );

  /*
   * Bundle-Vorschau vorhanden
   */
  if (discountPercent > 0) {
    if (bundleTotal) {
  bundleTotal.textContent =
    `Setpreis ${option.dataset.bundlePreviewTotal} statt ${option.dataset.bundleOriginalTotal}`;
}

if (bundleSaving) {
  bundleSaving.textContent =
    `Du sparst insgesamt ${option.dataset.bundleSaving}`;
}
    if (price) {
      price.textContent =
        option.dataset.previewPrice ||
        option.dataset.price ||
        '';
    }

    if (compare) {
      compare.textContent =
        option.dataset.price || '';

      compare.hidden = false;
    }

    if (saving) {
      saving.textContent =
        `-${discountPercent}% im Set · Du sparst ${option.dataset.saving}`;

      saving.hidden = false;
    }
  }

  /*
   * Kein Bundle-Vorschau-Rabatt:
   * normales Shopify Compare-at-Verhalten.
   */
  else {
    if (price) {
      price.textContent =
        option.dataset.price || '';
    }

    const priceCents =
      Number(option.dataset.priceCents || 0);

    const compareCents =
      Number(option.dataset.compareCents || 0);

    if (compare) {
      if (compareCents > priceCents) {
        compare.textContent =
          option.dataset.compare || '';

        compare.hidden = false;
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }
    }

    if (saving) {
      saving.hidden = true;
      saving.textContent = '';
    }
  }

  if (addButton) {
    addButton.dataset.variantId = option.value;
  }
}

  function scrollUpsells(button, direction) {
    const section = button.closest('[data-nt-upsell-section]');
    const track = section?.querySelector('[data-nt-upsell-track]');
    if (!track) return;

    track.scrollBy({
      left: direction * track.clientWidth,
      behavior: 'smooth',
    });
  }

  // function applyDiscountCode(form) {
  //   const input = form.querySelector('input[name="discount"]');
  //   const code = input?.value.trim();
  //   if (!code) return;

  //   try {
  //     sessionStorage.setItem('nt-cart-reopen-after-discount', '1');
  //   } catch (_) {}

  //   const redirect = `${window.location.pathname}${window.location.search}`;
  //   window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`;
  // }
  

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-nt-upsell-add]');
    if (addButton) {
      event.preventDefault();
      addUpsell(addButton);
      return;
    }

    const prev = event.target.closest('[data-nt-upsell-prev]');
    if (prev) {
      event.preventDefault();
      scrollUpsells(prev, -1);
      return;
    }

    const next = event.target.closest('[data-nt-upsell-next]');
    if (next) {
      event.preventDefault();
      scrollUpsells(next, 1);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-nt-upsell-variant]')) {
      updateUpsellPrice(event.target);
    }
  });

  // document.addEventListener('submit', (event) => {
  //   const form = event.target.closest('[data-nt-discount-form]');
  //   if (!form) return;
  //   event.preventDefault();
  //   applyDiscountCode(form);
  // });

  window.addEventListener('DOMContentLoaded', () => {
    let shouldReopen = false;

    try {
      shouldReopen = sessionStorage.getItem('nt-cart-reopen-after-discount') === '1';
      if (shouldReopen) sessionStorage.removeItem('nt-cart-reopen-after-discount');
    } catch (_) {}

    if (shouldReopen) {
      window.setTimeout(() => {
        const drawer = getDrawer();
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }, 250);
    }
  });
  document.addEventListener(
  'click',
  function (event) {
    const checkoutButton = event.target.closest('#CartDrawer-Checkout');

    if (!checkoutButton) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.location.assign('/checkout');
  },
  true
);
})();
